<template>
  <div>
    <Table
      resource="CourierService"
      :detail-route="row => `/courier-services/${row.id}/detail`"
      :actions="actions"
      :items="$store.getters['courierService/tableData']"
      :detail="$store.getters['courierService/detailData']"
      :fields="$store.getters['courierService/tableFields']"
      :pagination="$store.state.courierService.tablePagination"
      :keyword="$store.state.courierService.tableKeyword"
      :loading="$store.state.courierService.loadingTable"
      :filter="$store.state.courierService.tableFilter"
      :sort="$store.state.courierService.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/v2/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('courierService/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('courierService/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('courierService/delete', id)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    resetDetail() {
      this.$store.commit('courierService/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('courierService/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('courierService/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('courierService/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('courierService/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('courierService/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('courierService/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
